import { InfiniteData } from '@tanstack/react-query';
import { ValidationStatus } from 'src/api/getSchedules/types';
import type { IGetSchedulesResponse } from 'src/api/getSchedules/types';

export const assignScheduleStatus = (
  data: InfiniteData<IGetSchedulesResponse> | undefined,
  scheduleId: string,
  status: ValidationStatus,
): InfiniteData<IGetSchedulesResponse> | undefined => {
  if (!data) return data;
  return {
    ...data,
    pages: data.pages.map((page) => ({
      ...page,
      data: page.data.map((s) =>
        s.schedule_id === scheduleId ? { ...s, validation: { ...s.validation, status } } : s,
      ),
    })),
  };
};
